<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="senderStatuses"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>

</template>

<script>
    /**
     * Allows the selection of a sender type ID by choosing its name from
     * a selection downloaded from the API on creation
     */
    export default {
        name: 'ies-senderType',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                senderStatuses: [{"text": "New", "value": "New"}, {"text": "Sending", "value": "Sending"}, {"text": "Sent", "value": "Sent"}, {"text": "Failed", "value": "Failed"}],
                viewValue: parseInt(this.field.value),
            }
        },
        created:function() {},
        methods: {},
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>
